module.exports = __webpack_public_path__ + "static/img/histoire-04.b97fc10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-04.png
// module id = 89
// module chunks = 0